import { useState } from 'react';
import { TableHeader } from '../components/Analytics/types';

const useTableSort = (defaultSortBy: string, defaultSortOrder: string) => {
  const [sortOrder, setSortOrder] = useState(defaultSortOrder);
  const [sortByColumn, setSortByColumn] = useState(defaultSortBy);

  const handleHeaderSort = (e: TableHeader) => {
    if (e.key !== sortByColumn) {
      setSortByColumn(e.key);
      setSortOrder('desc');
    } else {
      setSortOrder(sortOrder === 'desc' ? 'asc' : 'desc');
    }
  };

  return { sortOrder, sortByColumn, handleHeaderSort };
};

export default useTableSort;
